/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const cityDataRequestSchema = z.object({
	id: z.string(),
	name: z.string(),
	radius: z.number(),
	region: z.object({ id: z.string(), name: z.string() }).nullable().optional(),
	country: z.object({ id: z.string(), name: z.string() }).nullable().optional(),
})

export type CityDataRequestSchema = z.infer<typeof cityDataRequestSchema>
